import React from 'react';
import utils from '../../../../utils/utils';

export const dashboardBuild = (setFilters: any) => {
    return [
        {
            type: 'simpleCount',
            dataTransformer: 'simpleCount',
            chartTitle: 'Total Activity Count',
            width: 3,
            dataType: 'reportCounts',
            height: 300,
        },
        {
            type: 'calendar',
            width: 9,
            chartTitle: 'Activities Per Day',
            dataTransformer: 'calendar',
            dataType: 'activitiesPerDay',
            legendAnchor: 'bottom-right',
            downloadableImage: true,
            downloadableCsv: true,
            groupBy: 'dateToString_createdAt',
            filterBy: 'createdAt',
            height: 300,
        },
        {
            type: 'pieChart',
            width: 4,
            chartTitle: 'Activities by Action Type',
            dataTransformer: 'pieChart',
            dataType: 'activityByAction',
            showPercent: true,
            downloadableImage: true,
            downloadableCsv: true,
            legend: true,
            legendAnchor: 'top-left',
            enableRadialLabels: false,
            filterBy: 'action',
            height: 500,
        },
        {
            type: 'barChart',
            width: 8,
            layout: 'horizontal',
            chartTitle: 'Number of Activities by User',
            dataTransformer: 'barChart',
            dataType: 'activityByUser',
            legendAnchor: 'bottom-right',
            color: 'nivo',
            downloadableImage: true,
            downloadableCsv: true,
            groupBy: 'userId',
            yLegend: 'Action Count',
            enableGridX: true,
            height: 500,
            withBrush: true,
            xAxisRotate: false,
            tickAmount: 10,
        },
        {
            type: 'divider',
        },
        {
            type: 'barChart',
            width: 8,
            layout: 'horizontal',
            chartTitle: 'Number of Activities by Workspace',
            dataTransformer: 'barChart',
            dataType: 'activityByWorkspaceId',
            legendAnchor: 'bottom-right',
            color: 'nivo',
            downloadableImage: true,
            downloadableCsv: true,
            groupBy: 'workspaceId',
            yLegend: 'Action Count',
            enableGridX: true,
            height: 500,
            withBrush: true,
            xAxisRotate: false,
            tickAmount: 10,
            aggregatedDataFilter: true,
            customFilterAggregation: (data: any, item: string) => {
                let valueInsideBrackets = data.slice(
                    data.indexOf('(') + 1,
                    data.indexOf(')')
                );
                const filter = {
                    workspaceId: {
                        id: 'workspaceId',
                        type: 'STRING',
                        operator: 'in',
                        values: [valueInsideBrackets],
                    },
                };
                setFilters(filter);
            },
        },
        {
            type: 'pieChart',
            width: 4,
            chartTitle: 'Activities by Collection',
            dataTransformer: 'pieChart',
            dataType: 'activityByCollection',
            showPercent: true,
            downloadableImage: true,
            downloadableCsv: true,
            legend: true,
            legendAnchor: 'top-left',
            enableRadialLabels: false,
            filterBy: 'collectionName',
            height: 500,
        },
        // {
        //     type: 'barChart',
        //     width: 6,
        //     layout: 'horizontal',
        //     chartTitle: 'Number of Actions by Case ID',
        //     dataTransformer: 'barChart',
        //     dataType: 'activityByCaseId',
        //     legendAnchor: 'bottom-right',
        //     color: 'nivo',
        //     downloadableImage: true,
        //     downloadableCsv: true,
        //     groupBy: 'id',
        //     yLegend: 'Import Count',
        //     enableGridX: true,
        //     height: 500,
        // },
        {
            type: 'tableComponent',
            width: 12,
            dataTransformer: 'tableComponent',
            chartTitle: 'List of Activities',
            dataType: 'activityTable',
            download: false,
            downloadableCsv: true,
            elevation: 0,
            filter: false,
            print: false,
            pagination: true,
            search: false,
            selectableRows: false,
            sort: true,
            rowsPerPageOptions: [10, 25, 50],
            viewColumns: false,
            serverSide: true,
            rowClick: false,
            idField: '_id',
            conversions: {
                createdAt: (d: any) => utils.formatDate(d),
                action: (v: string) => utils.toTitleText(v.toLowerCase()),
                collectionName: (v: string) =>
                    utils.toTitleText(v.split('-').join(' ')),
                userId: (v: string) => (
                    <span
                        style={{
                            filter:
                                v === 'betaTester@test.com'
                                    ? 'blur(3px)'
                                    : null,
                        }}
                    >
                        {v}
                    </span>
                ),
                transactionId: (v: string) => (
                    <a
                        href={`${process.env.REACT_APP_EXPLORER_URL}search-details/transaction/${v}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            fontFamily:
                                'Courier New,Courier,Lucida Sans Typewriter,Lucida Typewriter,monospace',
                            wordBreak: 'break-all',
                            color: '#757575',
                        }}
                    >
                        {v}
                    </a>
                ),
            },
        },
    ];
};
